export const sr = {
  translation: {
    common: {
      loading: "Učitavanje...",
      error: "Došlo je do greške",
      retry: "Pokušajte ponovo",
      close: "Zatvori",
      learnMore: "Saznajte više",
      contactUs: "Kontaktirajte nas",
      viewAll: "Pogledajte sve",
    },
  },
};